import { AppEnvironment } from '../app/core/config/app-config.model';

export const environment: AppEnvironment = {
  environment: 'dev',
  production: false,
  apiBaseUrl: 'https://api.numerical.co.in/v1',
  useMockTopics: false,
  gaMeasurementId: 'G-SDVSH8QM79',
  firebase: {
    apiKey: 'AIzaSyCXPq9tqrBcnhWvjQcSBUTMDkGjWmniEKU',
    authDomain: 'numerical2110.firebaseapp.com',
    databaseURL: 'https://numerical2110.firebaseio.com',
    projectId: 'numerical2110',
    storageBucket: 'numerical2110.appspot.com',
    messagingSenderId: '217129206120',
  },
};
